var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ai-robot__dialog",
      class: { "fullscreen-dialog": _vm.bFullscreen },
    },
    [
      _c("div", { staticClass: "yxtbiz-ai-robot__dialog--header" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-ai-robot__dialog--header-left" },
          [
            !_vm.bFullscreen && _vm.settings.assistHeadImg
              ? _c("yxtf-portrait", {
                  staticClass: "mr12",
                  attrs: {
                    size: "small",
                    username: "AI",
                    imgUrl: _vm.settings.assistHeadImg,
                  },
                })
              : _vm._e(),
            !_vm.bFullscreen
              ? _c("span", [_vm._v(_vm._s(_vm.title))])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "yxtbiz-ai-robot__dialog--header-right" },
          [
            !_vm.bFullscreen
              ? _c(
                  "yxtf-popconfirm",
                  {
                    attrs: {
                      title: _vm
                        .$t("pc_biz_ai_log_clear_confirm")
                        .d("确定清空此对话消息记录？"),
                      "hide-icon": "",
                    },
                    on: { confirm: _vm.clearHistory },
                  },
                  [
                    _c("header-icon", {
                      staticClass: "mr16",
                      attrs: {
                        slot: "reference",
                        size: _vm.iconSize,
                        "icon-name": "clear",
                        "pop-text": _vm.$t("pc_biz_ai_clear_log").d("清空记录"),
                        remote: "",
                      },
                      slot: "reference",
                    }),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.bFullscreen
              ? _c("header-icon", {
                  staticClass: "mr16",
                  attrs: {
                    size: _vm.iconSize,
                    "icon-name": "share",
                    "pop-text": _vm.$t("pc_biz_ai_share").d("分享"),
                    remote: "",
                  },
                  on: { click: _vm.share },
                })
              : _vm._e(),
            _vm.showShare && !_vm.bFullscreen ? _c("Share") : _vm._e(),
            !_vm.max
              ? [
                  _c("header-icon", {
                    staticClass: "mr16",
                    attrs: {
                      remote: "",
                      size: _vm.iconSize,
                      "icon-name": _vm.bFullscreen ? "window" : "fullscreen",
                      "pop-text": _vm.bFullscreen
                        ? _vm.$t("pc_biz_ai_small_window").d("小窗口")
                        : _vm.$t("pc_biz_ai_full_screen").d("全屏"),
                    },
                    on: { click: _vm.changeFullSize },
                  }),
                  _c("header-icon", {
                    staticClass: "mr16",
                    attrs: {
                      remote: "",
                      size: _vm.iconSize,
                      "icon-name": "ai-close",
                      "pop-text": _vm.$t("pc_biz_ai_close").d("关闭"),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "yxtbiz-ai-robot__dialog--body",
          style: _vm.aiBodyStyle,
        },
        [
          _c(
            "yxtf-scrollbar",
            {
              ref: "scrollbar",
              staticClass: "yxtbiz-ai-robot-scrollbar",
              attrs: { "fit-height": true },
            },
            [
              !_vm.noMoreHistory
                ? _c("infinite-scroll", {
                    attrs: { element: _vm.$refs.dialogBody },
                    on: { more: _vm.getHistory },
                  })
                : _vm._e(),
              _c(
                "ul",
                { ref: "dialogBody", staticClass: "is-msg-list" },
                _vm._l(_vm.msgList, function (msg, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: {
                        "yxtbiz-ai-robot__dialog--msg-question": msg.type,
                      },
                    },
                    [
                      _c("Message", {
                        attrs: {
                          msg: msg,
                          lastMsg: index === _vm.msgList.length - 1,
                          isWaitAnswer: _vm.isWaitAnswer,
                          fullscreen: _vm.bFullscreen,
                        },
                        on: {
                          feedback: function ($event) {
                            return _vm.showFeedbackDialog(index)
                          },
                          promot: _vm.onPromot,
                          resend: (val) => _vm.resend(msg, val, index),
                          scrollToEnd: _vm.scrollToEnd,
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "aiFooter", staticClass: "yxtbiz-ai-robot__dialog--footer" },
        [
          _c(
            "div",
            {
              class: {
                "textarea-content": true,
                "textarea-focus": _vm.focus,
                "more-lines": _vm.inputHeight > 53,
              },
            },
            [
              _vm.isWaitAnswer
                ? _c(
                    "span",
                    {
                      staticClass: "stop-answer",
                      on: {
                        click: function ($event) {
                          return _vm.stopAIAnswer()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "block" }),
                      _c("span", [_vm._v(" " + _vm._s("停止回答"))]),
                    ]
                  )
                : _vm._e(),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question,
                    expression: "question",
                  },
                ],
                ref: "textarea",
                class: { "no-question": !_vm.question },
                attrs: {
                  maxlength: "2000",
                  placeholder: _vm
                    .$t("pc_biz_ai_input_problem")
                    .d("请输入您要咨询的问题"),
                },
                domProps: { value: _vm.question },
                on: {
                  keydown: _vm.keydown,
                  focus: function ($event) {
                    _vm.focus = true
                  },
                  blur: function ($event) {
                    _vm.focus = false
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.question = $event.target.value
                  },
                },
              }),
              _vm.question
                ? _c(
                    "div",
                    {
                      class: {
                        "ai-robot-btn-send": true,
                        "disbale-send": _vm.isWaitAnswer,
                      },
                      on: { click: _vm.sendMsg },
                    },
                    [_c("img", { attrs: { src: _vm.sendSvg } })]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }